import cooperators from "./cooperators";
import cooperatorCaseStudies from "./case-studies/cooperators";
import xeCaseStudies from "./case-studies/xe";
import xe from "./xe";

export const workTransformations = [
  {
    ...cooperators,
    icon: "organization",
    caseStudies: cooperatorCaseStudies,
  },
  {
    ...xe,
    icon: "global",
    caseStudies: xeCaseStudies,
  },
];

export const getWorkTransformation = (id) =>
  workTransformations.find((transformation) => transformation.id === id);

export const getWorkCaseStudy = (transformation, slug) =>
  transformation?.caseStudies.find((caseStudy) => caseStudy.slug === slug);

export const workCaseStudySequence = workTransformations.flatMap(
  (transformation) => [
    {
      type: "overview",
      slug: null,
      title: transformation.title,
      transformationId: transformation.id,
      transformationLabel: transformation.label,
      path: `/work/${transformation.id}`,
    },
    ...transformation.caseStudies.map((caseStudy) => ({
      ...caseStudy,
      type: "case-study",
      transformationId: transformation.id,
      transformationLabel: transformation.label,
      path: `/work/${transformation.id}/${caseStudy.slug}`,
    })),
  ],
);

export const getAdjacentWorkCaseStudies = (transformationId, slug) => {
  const currentIndex = workCaseStudySequence.findIndex(
    (caseStudy) =>
      caseStudy.transformationId === transformationId &&
      caseStudy.slug === (slug || null),
  );

  if (currentIndex < 0) {
    return { previous: null, next: null };
  }

  return {
    previous: workCaseStudySequence[currentIndex - 1] || null,
    next: workCaseStudySequence[currentIndex + 1] || null,
  };
};

export default workTransformations;
